import React from 'react'
import './testimonials.css'
import AVTR1 from '../../assets/avatar1.jpg'
import AVTR2 from '../../assets/avatar2.jpg'
import AVTR3 from '../../assets/avatar3.jpg'
import AVTR4 from '../../assets/avatar4.jpg'
import AVTR from '../../assets/avatar.jpg'

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import { Pagination, Navigation } from "swiper";

const data = [
    {
        avatar: AVTR,
        name: 'Peter Kiprotich',
        title: 'Instructional Designer at Maseno E-Campus',
        review:
            "Working with Simon was a game-changer for our project. He not only delivered scalable solutions but also guided us through the implementation process with clarity and professionalism. His ability to balance technical depth with practical execution made the entire experience seamless."
    },
    {
        avatar: AVTR,
        name: 'Simon Kimathi',
        title: 'Senior Developer at Systech Limited',
        review:
            "Simon is one of the most reliable developers I’ve had the chance to collaborate with. His technical expertise spans across multiple domains, and he always takes the time to explain complex ideas in simple, actionable terms. He doesn’t just deliver code — he delivers confidence in the solution."
    },
    {
        avatar: AVTR,
        name: 'Mark Mwima',
        title: 'Senior Software Engineer at Smart Access',
        review:
            "Every interaction with Simon has been marked by professionalism and precision. He brings a unique blend of creativity and structure, ensuring that the solutions are not only functional but also optimized for long-term growth. I would trust him with any critical system build."
    },
    {
        avatar: AVTR,
        name: 'John Kamau',
        title: 'Software Engineer at Armitrac Technologies',
        review:
            "Simon’s problem-solving skills are outstanding. He approaches challenges with a cool head, breaks them down logically, and always finds innovative solutions. Beyond his technical ability, he has the rare quality of being a great team player who uplifts everyone around him."
    }
];


const Testimonials = () => {
    return (
        <section id='testimonials'>
            <h5>What Clients Say</h5>
            <h2>Testimonials</h2>

            <Swiper
                className="container testimonials__container"
                modules={[Pagination, Navigation]}
                navigation
                spaceBetween={40}
                breakpoints={{
                    640: { slidesPerView: 1 },
                    1024: { slidesPerView: 1 },
                }}
                pagination={{ clickable: true }}
            >
                {data.map(({ avatar, name, title, review }, index) => (
                    <SwiperSlide className="testimonial" key={index}>
                        <div className="client__avatar">
                            <img src={avatar} alt={`Avatar of ${name}`} />
                        </div>
                        <h5 className="client__name">{name}</h5>
                        <small className="client__title">{title}</small>
                        <p className="client__review">"{review}"</p>
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    )
}

export default Testimonials
